import React from 'react';
import '../../pages/About/AboutPage.css'
import { Link } from 'react-router-dom';
import cv from '../../cv/cv.docx';
import { ButtomGet } from '../ButtomGet/ButtomGet';



const About = () => (
    <section className="sobre-mi" id="sobre-mi">
        <h2 className="heading">About me</h2>

        <div className="row container">
            <div className="columns" data-aos="fade-right" data-aos-delay="300">
                <h3>Who Am I?</h3>
                <h4>My name is Abhay Kumar and I am a full stack developer.</h4>
                <p>I've immersed myself in the world of web design and development — learning, experimenting, and constantly improving. What started as curiosity has grown into a passion for crafting responsive, engaging, and meaningful digital experiences.</p>
                <p>With expertise in modern web technologies, I specialize in creating scalable applications using React, Node.js, and cloud platforms. I enjoy solving complex problems and turning innovative ideas into reality through clean, efficient code.</p>
               
                <ul>
                    <li>
                        <p>
                            <span>Age:</span>
                            21
                        </p>
                    </li>
                    <li>
                        <p>
                            <span>
                                Hobbies:{" "}
                            </span>
                                Chess, Cricket and Programming
                        </p>
                    </li>
                    <li>
                        <p><span>Email:</span> abhaypro.cloud@gmail.com</p>
                    </li>
                    <li>
                        <p>
                            <span>From:</span>
                            Kolkata, India
                        </p>
                    </li>
                </ul>
                <div className="mas-info">
                    <a href={cv} target="_blank" rel="noopener noreferrer" download="cv.docx" className="btn-codigo buttonDownload">
Download CV
                    </a>
                    <div className='mas-info-btn'>
                    <a href="https://www.linkedin.com/in/abhayclasher/" target="_blank" rel="noopener noreferrer">
                        <ButtomGet/>
                    </a>
                    </div>
                </div>
            </div>
            <div className="columns col-skill scroll-3d section-3d" data-aos="fade-left" data-aos-delay="650">
                <h3>skills</h3>
                <h4>Front-End</h4>
                <div className="skill scroll-3d">
                    <div className="skill-card-3d">
                        <img alt="HTML" className="icons-skils" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg" />
                        <h5>HTML</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="CSS" className="icons-skils" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg" />
                        <h5>CSS</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Js" className="icons-skils" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg" />
                        <h5>JavaScript</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Sass" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg" />
                        <h5>Sass</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Bootstrap" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" />
                        <h5>Bootstrap</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="jQuery" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-plain-wordmark.svg" />
                        <h5>jQuery</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="React" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" />
                        <h5>React</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="TypeScript" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" />
                        <h5>TypeScript</h5>
                    </div>
                </div>
                <h4>Back-End</h4>
                <div className="skill scroll-3d">
                    <div className="skill-card-3d">
                        <img alt="Nodejs" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" />
                        <h5>NodeJs</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="API" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg" />
                        <h5>API</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Python" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" />
                        <h5>Python</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="mongodb" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg" />
                        <h5>MongoDB</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="php" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" />
                        <h5>PHP</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="MySQL" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" />
                        <h5>MySQL</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Firebase" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" />
                        <h5>Firebase</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="PostgreSQL" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" />
                        <h5>PostgreSQL</h5>
                    </div>
                </div>
                <h4>Tools</h4>
                <div className="skill scroll-3d">
                    <div className="skill-card-3d">
                        <img alt="figma" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" title="figma" />
                        <h5>Figma</h5>
                    </div>

                    <div className="skill-card-3d">
                        <img alt="Visual Studio Code" className="icons-skils" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Visual_Studio_Code_1.18_icon.svg/1200px-Visual_Studio_Code_1.18_icon.svg.png" title="Visual Studio Code" />
                        <h5>VS Code</h5></div>
                    <div className="skill-card-3d">
                        <img alt="Git" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" />
                        <h5>Git</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Netlify" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/netlify/netlify-original.svg" />
                        <h5>Netlify</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Docker" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" />
                        <h5>Docker</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="AWS" className="icons-skils" src="https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg" />
                        <h5>AWS</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="GCP" className="icons-skils" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg" />
                        <h5>GCP</h5>
                    </div>
                    <div className="skill-card-3d">
                        <img alt="Postman" className="icons-skils" src="https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" />
                        <h5>Postman</h5>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default React.memo(About);